module.exports = __webpack_public_path__ + "img/_ABS9809.bf8f0776.jpg";